const config = {
  rowSelection: false,
  scroll: {
    y: 'calc(100vh - 550px)',
  },
  columns: [
    {
      title: '报价类型',
      dataIndex: 'quoteTypeName',
      width: 150,
    },
    {
      title: '报价合同配置ID',
      dataIndex: 'quotaContractId',
      width: 150,
      render: 'idRender',
    },
    {
      title: '合同标题',
      dataIndex: 'title',
      width: 150,
    },
    {
      title: '适用门店',
      dataIndex: 'orgName',
      width: 150,
    },
    {
      title: '顺序',
      dataIndex: 'priority',
      width: 80,
    },
    {
      title: '开始日期',
      dataIndex: 'startDate',
      width: 120,
      render: 'startDateRender',
    },
    {
      title: '结束日期',
      dataIndex: 'endDate',
      width: 120,
      render: 'endDateRender',
    },
  ],
  searchTypeWidth: 160,
  search: [
    {
      name: 'quoteType',
      label: '报价类型',
      data: 'budgetList',
      itemType: 'select',
      labelKey: 'name',
      key: 'code',
    },
    {
      name: 'quotaContractId',
      label: '报价合同配置ID',
      itemType: 'input',
    },
    {
      name: 'title',
      label: '合同标题',
      itemType: 'input',
    },
    {
      name: 'orgId',
      label: '适用门店',
      itemType: 'select',
      data: 'orgList',
      labelKey: 'name',
      key: 'id',
    },
  ],
  footer: false,
}

export default config
